import React, { useMemo, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const Intervieews = () => {
  return (
    <div className="bg-[#f0f4fc] min-h-screen">
      <div className=" p-10">
        <div className="flex items-center justify-between">
        <p className="text-2xl font-semibold">Interviewees</p>
        
        </div>
        <div className="p-4 mt-6 bg-white rounded-xl">
          <div className="flex w-full items-end justify-start space-x-5">
            <div>
              <p className="font-semibold">Job Title</p>
              <select className="border px-1 py-1 rounded-lg mt-1"  >
                <option value="i">Introduction</option>
                <option value="ct">Critical Thinking</option>
                <option value="ls">Active Listening</option>
                <option value="gm">Growth Mindset</option>
                <option value="comm">Communication</option>
                <option value="tw">Teamwork</option>
              </select>
            </div>
            <div>
              <p className="font-semibold">Date</p>
              <input className="border px-1 py-1 rounded-lg mt-1"  type="date"></input>
            </div>
            <div>
              <p className="font-semibold">Work Style</p>
              <select className="border w-32 px-1 py-1 rounded-lg mt-1"  >
                <option value="i">On-site</option>
                <option value="ct">Remote</option>
                <option value="ls">Hybrid</option>
              </select>
            </div>
            <button className="py-2 h-full  bg-[#148EFF] text-white px-12 rounded-lg">Search</button>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Intervieews